/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Dispatch } from 'redux'
import { getAllAvailabilities, getPage } from '../../api/api'
import { MeetingPage } from '../../types/plann3r'
import { receiveAllAvailabilities,
  REQUEST_ALL_AVAILABILITIES } from '../availabilities/actions'
import { SET_FOOTER_COLORS } from '../general/actions'

export const REQUEST_MEETING_PAGE_DETAILS = 'REQUEST_MEETING_PAGE_DETAILS'
export const requestLinkDetails = (company: string, pageName: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: REQUEST_MEETING_PAGE_DETAILS })

    const page:MeetingPage = await getPage(company, pageName)

    if (page.id) {
      dispatch({ type: RECEIVE_MEETING_PAGE_DETAILS, page })

      dispatch({
        type: SET_FOOTER_COLORS,
        colors: {
          primary: page.colors.primary,
          secondary: page.colors.secondary,
        },
      })

      dispatch({
        type: REQUEST_ALL_AVAILABILITIES,
      })

      const allAvailabilities = await getAllAvailabilities(page.id)

      dispatch(receiveAllAvailabilities(allAvailabilities))
    } else {
      alert('This page does not exist.')
    }
  }
}

export const RECEIVE_MEETING_PAGE_DETAILS = 'RECEIVE_MEETING_PAGE_DETAILS'
export const receiveLinkDetails = (page: MeetingPage) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: RECEIVE_MEETING_PAGE_DETAILS,
      page: page,
    })
  }
}

export const SET_MEETING_PAGE_RESPONSE_RECEIVED =
  'SET_MEETING_PAGE_RESPONSE_RECEIVED'
export const setLinkResponseReceived = () => {
  return {
    type: SET_MEETING_PAGE_RESPONSE_RECEIVED,
  }
}

export const MEETING_PAGE_UPDATE_IS_VIDEOCALL =
  'MEETING_PAGE_UPDATE_IS_VIDEOCALL'
export const linkUpdateIsVideoCall = (isVideoCall: boolean) => {
  return {
    type: MEETING_PAGE_UPDATE_IS_VIDEOCALL,
    isVideoCall,
  }
}

export const MEETING_PAGE_UPDATE_VALUE = 'MEETING_PAGE_UPDATE_VALUE'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const linkUpdateValue = (id: number, value: string) => {
  return {
    type: MEETING_PAGE_UPDATE_VALUE,
    value,
    id,
  }
}

export const MEETING_PAGE_UPDATE_DURATION = 'MEETING_PAGE_UPDATE_DURATION'
export const linkUpdateMeetingDuration = (duration: number) => {
  return (dispatch: Dispatch) => {
    dispatch({ type: MEETING_PAGE_UPDATE_DURATION, duration })
  }
}

export const MEETING_PAGE_SET_MOMENT_PICKING = 'MEETING_PAGE_SET_MOMENT_PICKING'
export const meetingPageSetMomentPicking = (pick_moment: boolean) => {
  return {
    type: MEETING_PAGE_SET_MOMENT_PICKING,
    pick_moment,
  }
}
